import React from 'react';
import { Gift, Check } from 'lucide-react';
import { CTAButton } from './CTAButton';
import { optimizeImg } from '../utils/img';
const bonuses = [{
  id: 1,
  title: 'Aromaterapia Fácil en 7 Minutos',
  desc: 'Aprende mezclas simples para relajarte y crear ambientes más agradables.',
  img: 'https://cdn.magicpatterns.com/uploads/d6wuvX8RFGi9o5bupxw4HM/2c4637fe-1f6d-4a52-9743-42a05130cffa.png',
  value: '99'
}, {
  id: 2,
  title: 'Botiquín Natural Infantil',
  desc: 'Alternativas naturales organizadas para situaciones cotidianas de los más pequeños.',
  img: 'https://cdn.magicpatterns.com/uploads/8DoJUC4SSoWBHDSCiUCvgu/ChatGPT_Image_22_may_2026,_00_45_27.png',
  value: '149'
}, {
  id: 3,
  title: 'Kit de Urgencias Naturales',
  desc: 'Soluciones rápidas y efectivas para tener siempre a la mano en casa.',
  img: 'https://cdn.magicpatterns.com/uploads/5hrLReBvZTmNaS63JzUoYb/ChatGPT_Image_22_may_2026,_00_57_44.png',
  value: '129'
}, {
  id: 4,
  title: 'Baños Mágicos y Sahumerios',
  desc: 'Rituales naturales para limpiar la energía, relajar el cuerpo y atraer bienestar.',
  img: 'https://cdn.magicpatterns.com/uploads/w1X6ed42JUf1Z62HxXiNEZ/ChatGPT_Image_22_may_2026,_00_40_01.png',
  value: '89'
}, {
  id: 5,
  title: 'SOS 7 Días Antiinflamación',
  desc: 'Menú completo y simple para desinflamar el cuerpo en una semana.',
  img: 'https://cdn.magicpatterns.com/uploads/79rzUdSC39YehRV1P7Xkwe/ChatGPT_Image_22_may_2026,_00_42_46.png',
  value: '119'
}, {
  id: 6,
  title: 'Guía Herbal Femenina',
  desc: 'Plantas aliadas para acompañar cada etapa y ciclo de la mujer.',
  img: 'https://cdn.magicpatterns.com/uploads/tUmJxSm5Uo22ve9k2yMPYM/ChatGPT_Image_22_may_2026,_00_43_55.png',
  value: '99'
}, {
  id: 7,
  title: 'Belleza Herbal',
  desc: 'Recetas naturales, económicas y sin químicos para cuidar tu piel y cabello.',
  img: 'https://cdn.magicpatterns.com/uploads/gweP7JukoNyKKZ6gDLNM7q/ChatGPT_Image_22_may_2026,_00_46_38.png',
  value: '79'
}, {
  id: 8,
  title: 'Cocina en 10 Minutos',
  desc: 'Comidas naturales, fáciles y rápidas para cuando no tienes tiempo.',
  img: 'https://cdn.magicpatterns.com/uploads/47u2dodKPNkxZdoD2wmhuA/ChatGPT_Image_22_may_2026,_00_48_12.png',
  value: '69'
}, {
  id: 9,
  title: 'Protocolos Express por Síntoma',
  desc: 'Guía de acción inmediata para saber exactamente qué hacer ante cada molestia.',
  img: 'https://cdn.magicpatterns.com/uploads/4KG9Q8NTQ3Dt213v8srbgK/ChatGPT_Image_22_may_2026,_00_49_29.png',
  value: '89'
}, {
  id: 10,
  title: 'Conserva Tus Hierbas',
  desc: 'El método exacto para guardar y conservar tus plantas para que duren meses.',
  img: 'https://cdn.magicpatterns.com/uploads/ec3GYcS3R4sUmRsRJTdCQU/ChatGPT_Image_19_may_2026,_00_39_10.png',
  value: '79'
}];
export function Bonuses() {
  return <section className="py-8 md:py-12 px-5 bg-cream-50" data-id="element-36">
      <div className="max-w-4xl mx-auto" data-id="element-37">
        {/* Header */}
        <div className="text-center mb-10 md:mb-14 max-w-2xl mx-auto" data-id="element-38">
          <div className="inline-flex items-center gap-2 bg-terracotta-500/10 text-terracotta-600 px-4 py-1.5 rounded-full text-xs font-medium mb-5" data-id="element-39">
            <Gift className="w-3.5 h-3.5" data-id="element-40" />
            10 guías premium incluidas
          </div>
          <h2 className="font-serif font-medium text-3xl md:text-4xl text-ink-900 leading-tight mb-4" data-id="element-41">
            Y además,{' '}
            <span className="italic text-olive-600" data-id="element-42">10 guías digitales</span> de
            bono
          </h2>
          <p className="text-ink-700 text-base md:text-lg leading-relaxed" data-id="element-43">
            Hoy se suman a tu pedido para que tu biblioteca natural sea todavía
            más completa.
          </p>
        </div>

        {/* Bonus list — text only, clean rows */}
        <div className="space-y-3 mb-12 max-w-2xl mx-auto" data-id="element-44">
          {bonuses.map(bonus => <div key={bonus.id} className="w-full rounded-2xl border-2 border-cream-300 bg-cream-50 p-4 md:p-5 flex items-start gap-3 md:gap-4 hover:border-olive-300 transition-colors" data-id="element-45">
              {/* Numbered gift badge */}
              <div className="flex-shrink-0 w-9 h-9 rounded-full bg-olive-100 flex items-center justify-center" data-id="element-46">
                <Gift className="w-4 h-4 text-olive-700" strokeWidth={2} data-id="element-47" />
              </div>

              {/* Body */}
              <div className="flex-1 min-w-0" data-id="element-48">
                <p className="text-[10px] md:text-xs uppercase tracking-wider text-olive-600 font-bold mb-1" data-id="element-49">
                  BONO EXCLUSIVO #{bonus.id}
                </p>
                <h3 className="font-serif font-medium text-base md:text-lg text-ink-900 leading-tight mb-1.5" data-id="element-50">
                  {bonus.title}
                </h3>
                <p className="text-xs md:text-sm text-ink-700 leading-snug mb-2" data-id="element-51">
                  {bonus.desc}
                </p>

                <div className="flex items-center gap-2 flex-wrap" data-id="element-52">
                  <span className="text-xs text-ink-500 line-through" data-id="element-53">
                    ${bonus.value} MXN
                  </span>
                  <span className="text-[10px] md:text-xs font-bold tracking-wider bg-terracotta-500 text-cream-50 px-2 py-0.5 rounded-full" data-id="element-54">
                    HOY GRATIS
                  </span>
                </div>
              </div>
            </div>)}
        </div>

        {/* Value summary */}
        <div className="bg-olive-700 text-cream-50 rounded-3xl p-8 md:p-10 shadow-2xl max-w-2xl mx-auto relative overflow-hidden" data-id="element-55">
          <div className="absolute inset-0 opacity-10 bg-[radial-gradient(circle_at_center,_var(--tw-gradient-stops))] from-cream-50 to-transparent" data-id="element-56"></div>

          <div className="relative z-10" data-id="element-57">
            <h3 className="font-serif text-2xl md:text-3xl font-medium text-center mb-8" data-id="element-58">
              Resumen de tu biblioteca
            </h3>

            <div className="space-y-4 mb-8 text-sm md:text-base" data-id="element-59">
              <div className="flex justify-between items-center border-b border-olive-600 pb-3" data-id="element-60">
                <span className="text-cream-200" data-id="element-61">Biblioteca principal:</span>
                <span className="font-medium" data-id="element-62">$499</span>
              </div>
              <div className="flex justify-between items-center border-b border-olive-600 pb-3" data-id="element-63">
                <span className="text-cream-200" data-id="element-64">10 Bonos Premium:</span>
                <span className="font-medium" data-id="element-65">$500</span>
              </div>
              <div className="flex justify-between items-center pt-2" data-id="element-66">
                <span className="text-cream-200" data-id="element-67">Valor total:</span>
                <span className="font-medium line-through opacity-70" data-id="element-68">
                  $999
                </span>
              </div>
            </div>

            <div className="bg-cream-50 text-ink-900 rounded-2xl p-6 text-center mb-8" data-id="element-69">
              <p className="text-sm font-medium text-ink-600 mb-1 uppercase tracking-wider" data-id="element-70">
                Hoy llevas todo por
              </p>
              <p className="font-serif text-5xl md:text-6xl font-semibold text-olive-700 mb-2" data-id="element-71">
                $299
              </p>
              <div className="inline-flex items-center gap-1.5 bg-terracotta-100 text-terracotta-700 px-3 py-1 rounded-full text-xs font-bold" data-id="element-72">
                <Check className="w-3.5 h-3.5" strokeWidth={3} data-id="element-73" />
                Ahorras $700
              </div>
            </div>

            <CTAButton variant="primary" className="w-full" data-id="element-74" />
          </div>
        </div>
      </div>
    </section>;
}